import {
  CommonHeaderIntercepotr,
  LOGINEncryptInterceptor,
  LOGINDecryptInterceptor,
  VconsoleRequestInterceptor,
  VconsoleResponseInterceptor,
  ECDHEncryptInterceptor,
  ECDHDecryptInterceptor,
  SentryReportInterceptor,
} from '@fs/http'
import customizeHeaderInterceptor from './customizeHeaderInterceptor'
import mrInterceptor from './mrInterceptor'
import outsideH5LogoutInterceptor from './outsideH5LogoutInterceptor'
import cmhkLogoutInterceptor from './cmhkLogoutInterceptor'
import freezeAccountInterceptor from './freezeAccountInterceptor'
import { getRunEnv, isHLApp, isInOutsideH5 } from '@fs/utils'
import { getAppLocale, toLegacyLangType } from '@repo/common-utils/utils/appLocale'
import { getXSource } from '../http.tool'
import thsLogoutInterceptor from './thsLogoutInterceptor'
import outsideH5ExtendSessionInterceptor from './outsideH5ExtendSessionInterceptor'
import { captureException } from '@sentry/vue'

const { VUE_APP_ENV, VUE_APP_PUBLIC_KEY, VUE_APP_SIGN_KEY } = import.meta.env
const NODE_ENV = import.meta.env.MODE

export default function (http) {
  try {
    const ECDHKeys = {
      PUBLIC_KEY: VUE_APP_PUBLIC_KEY,
      SIGN_KEY: VUE_APP_SIGN_KEY,
    }

    http.registerInterceptor(
      'request',
      LOGINEncryptInterceptor({
        VUE_APP_ENV: VUE_APP_ENV,
      })
    )
    http.registerInterceptor('request', ECDHEncryptInterceptor(ECDHKeys))
    http.registerInterceptor('request', VconsoleRequestInterceptor())
    http.registerInterceptor('request', customizeHeaderInterceptor)

    // uin、session、lang、xSource、rndKey
    const sessionKey = getRunEnv() === 2 ? 'WTtoken' : 'session'
    const session = () => localStorage.getItem(sessionKey) || ''
    const uin = () => localStorage.getItem('uin') || ''
    const rndKey = () => localStorage.getItem('rndKey') || ''
    http.registerInterceptor(
      'request',
      CommonHeaderIntercepotr({
        uin,
        session,
        rndKey,
        lang: () => toLegacyLangType(getAppLocale()),
        xSource: getXSource(),
        product: 'pages',
        NODE_ENV,
        channel: 'H5',
      })
    )

    http.registerInterceptor('request', async (config) => {
      return config
    })

    http.registerInterceptor('response', ECDHDecryptInterceptor(ECDHKeys))
    http.registerInterceptor('response', LOGINDecryptInterceptor({ NODE_ENV }))
    http.registerInterceptor('response', SentryReportInterceptor(captureException, true))
    http.registerInterceptor('response', VconsoleResponseInterceptor())

    // 处理冻结
    http.registerInterceptor('response', freezeAccountInterceptor)
    if (!isHLApp()) {
      http.registerInterceptor('response', mrInterceptor)
      http.registerInterceptor('response', outsideH5LogoutInterceptor)
      http.registerInterceptor('response', cmhkLogoutInterceptor())
      http.registerInterceptor('response', thsLogoutInterceptor)
    }
    // 处理站外H5登录态展期
    if (isInOutsideH5()) http.registerInterceptor('response', outsideH5ExtendSessionInterceptor)
  } catch (e) {
    console.log(`Feng.chen:: 16:20:43 e ===> `, e)
  }
}
